import { useEffect } from "react";

const BASE = "PsyGestion";

/** Set document.title on mount. Resets to base on unmount. */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} : Pilotez votre Revenu Net Libéral`;
    return () => {
      document.title = `${BASE} : Pilotez votre Revenu Net Libéral`;
    };
  }, [title]);
}
